/*
 * Created on Thu Dec 19 2019
 *
 * Copyright (c) 2019 Primas Group
 * Create by Gia Nguyen
 */

import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpErrorResponse, HttpResponse, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { catchError, tap, map, takeUntil } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { NbToastrService } from '@nebular/theme';
import { ActivationEnd, Router } from '@angular/router';
import { CancelRequestService } from './shared/services/cancel-request.service';
import { apiVersion, environment } from 'src/environments/environment';
import { isKeycloakExchangeRequest } from './shared/services/keycloak-exchange.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private inj: Injector, private toast: NbToastrService, private router: Router, private cancelRequestService: CancelRequestService) {
        router.events.subscribe(event => {
            // An event triggered at the end of the activation part of the Resolve phase of routing.
            if (event instanceof ActivationEnd) {
                // Cancel pending calls
                //   this.cancelRequestService.cancelPendingRequests();
            }
        });
    }
    // tslint:disable-next-line: max-line-length
    intercept(req: import('@angular/common/http').HttpRequest<any>, next: import('@angular/common/http').HttpHandler): import('rxjs').Observable<import('@angular/common/http').HttpEvent<any>> {
        const customReq = req.clone({ headers: req.headers.set("CurrentRoute", window.location.pathname) });

        return next.handle(customReq).pipe(
            // Add instance services to drop all pending requests:
            takeUntil(this.cancelRequestService.onCancelPendingRequests()),
            tap((event: HttpResponse<any>) => {
                //status code 200
                if (event instanceof HttpResponse) {
                    if (event.body && event.body.message) {
                        setTimeout(() => {
                            this.toast.danger(event.body.message, 'Error');
                        }, 1000);
                    }
                }
            }),
            catchError(error => {
                console.log(error);
                // The Keycloak exchange endpoint owns its own failure handling. A 401 from it is
                // legitimate and permanent — the SSO account has no BackOffice counterpart, or is
                // deleted/inactive — and LoginComponent renders that as its "denied" panel.
                // Redirecting to /auth here would fight that UI, and "Your username or password is
                // incorrect" is simply untrue for a sign-in that involved no password.
                //
                // Rethrows the original HttpErrorResponse rather than error.statusText like the
                // branches below, so the caller can still read .status off it.
                if (isKeycloakExchangeRequest(req.url)) {
                    return throwError(error);
                }
                if (error.status === 401 || error.status === 0) {
                    if (error.status === 404 || error.status === 401) {
                        this.router.navigate([`/auth`]);
                        setTimeout(() => {
                            this.toast.danger(error.status == 401 ? 'Your username or password is incorrect. Please try again' : 'Sorry, the system has an unexpected technical issue.', 'Error');
                        }, 1000);
                        return throwError(error.statusText);
                    } else if(error.url.startsWith('https://altus.primas.net:8030/images/')){
                        return throwError(error.statusText);
                    }else {
                        setTimeout(() => {
                            this.toast.danger('Sorry, the system has an unexpected technical issue.', 'Error');
                        }, 1000);
                        return throwError(error.statusText);
                    }

                }
                if (error.status === 302) {
                    this.router.navigate([`/expired`]);
                    return;
                }
                if (error instanceof HttpErrorResponse) {
                    var urlsBlock = [`/api/${apiVersion}/CRM/`];
                    var isMessage = true;
                    try {
                        for (var url of urlsBlock) {
                            if (error.url && error.url.includes(url)) {
                                isMessage = false;
                                break;
                            }
                        }

                        if (!isMessage) return throwError(new CRMserverError("CRM Server is not available"));
                    }
                    catch (ex) {
                        console.error(ex);
                    }

                    const applicationError = error.headers.get('Application-Error');
                    if (applicationError) {
                        setTimeout(() => {
                            this.toast.danger(applicationError, 'Error');
                        }, 1000);
                        return throwError(applicationError);
                    }

                    const serverError = error.error;
                    let modelStateError = '';
                    if (serverError && typeof serverError === 'object') {
                        if (!serverError.success) {
                            modelStateError = serverError.message == null ? '' : serverError.message;
                            if (typeof serverError.errors === 'object') {
                                for (const key in serverError.errors) {
                                    if (serverError.errors[key]) {
                                        modelStateError += serverError.errors[key] + '\n';
                                    }
                                }
                            }
                        }
                    }
                    setTimeout(() => {
                        this.toast.danger(modelStateError || 'Server Error', 'Error');
                    }, 1000);
                    return throwError(modelStateError || 'Server Error');
                }
            }));

    }

}
@Injectable()
export class MultiTenantInterceptor implements HttpInterceptor {
  intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authReq = req;
    const tenantId = sessionStorage.getItem("TenantId");
    if(tenantId != undefined) {
        authReq = req.clone({headers: req.headers.set('TenantId', tenantId ?? '')});
    }
    else {
        if(!req.headers.has('TenantId')) {
            const tenantValue = req.headers.get("TenantId");
            authReq =  req.clone({ headers: req.headers.delete('TenantId', tenantValue) });
        }
    }
    return next.handle(authReq);

  }
}
export class CRMserverError extends Error
{
    constructor(msg: string) {
        super(msg);
        Object.setPrototypeOf(this, CRMserverError.prototype);
    }
}
